var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinalDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: "             409.429,347.499 409.429,450 69.43,450 69.43,10 319.43,10 409.429,100 409.429,157.501  ",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: "             404.429,100 319.43,100 319.43,15  ",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: "             357.428,455 357.428,502.002 17.428,502.002 17.428,49.458 64.43,49.458  ",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 159.925,
    y1: 108.75,
    x2: 228.935,
    y2: 108.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 114.43,
    y1: 207.5,
    x2: 322.429,
    y2: 207.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 114.43,
    y1: 252.5,
    x2: 218.43,
    y2: 252.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 114.43,
    y1: 297.5,
    x2: 279.285,
    y2: 297.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 239.43,
    y1: 342.499,
    x2: 279.285,
    y2: 342.499,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 239.43,
    y1: 387.499,
    x2: 364.43,
    y2: 387.499,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: "             181.93,342.499 136.93,387.5 114.43,365  ",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    d: "             M346.786,297.5h125.289c12.374,0,22.499,10.125,22.499,22.5v22.5H324.286v-22.5C324.286,307.624,334.411,297.5,346.786,297.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    d: "             M382.355,294.976L374.43,197.5c-1.582-19.454,16.374-35,35-35c19.25,0,36.56,15.814,35,35l-7.925,97.475",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.43,
    y: 55,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 20.0001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    width: 160,
    height: 107.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalDesign);
export default __webpack_public_path__ + "static/media/final_design.3e9bdd34a55fd66875d37d070673d78f.svg";
export { ForwardRef as ReactComponent };